import { render } from "./GarantidorasView.vue?vue&type=template&id=8f112cde&scoped=true"
import script from "./GarantidorasView.vue?vue&type=script&lang=js"
export * from "./GarantidorasView.vue?vue&type=script&lang=js"

import "./GarantidorasView.vue?vue&type=style&index=0&id=8f112cde&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f112cde"]])

export default __exports__